export default __webpack_public_path__ + "images/logo-100x22-white.svg";